<template>
    <div v-if="lang" class="row bg-white padding-flex mb-1">
        <div class="container box-full pr-0">
            <div class="row">
                <template>
                    <div v-if="$root.is_mobile" class="d-flex align-items-center w-100">
                        <div class="col-9 col-md-11 pl-0 estate-price" >
                            <span class="current-price" v-html="estate.price"></span>
                            <span v-if="estate.price_alternative" class="current-price-euro" v-html="estate.price_alternative"></span>
                            <estate-discount :estate="estate" />
                        </div>

                        <estate-actions :estate="estate" />

                        <div class="share-button">
                            <estate-share
                                :estate="estate"
                                :estate-id="estate.id"
                                :agency-id="estate.agency ? estate.agency.id : null"
                                :type="estate.ad_type"
                            >
                            </estate-share>
                        </div>
                    </div>
                    
                    <div class="col-xl-9 col-lg-9 col-md-8 pl-0" v-if="! $root.is_mobile">
                        <h1 class="estate-title">
                            {{ estate.title }}
                        </h1>
                        <h2 class="estate-subtitle">
                            {{ estate.subtitle }}
                        </h2>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-4 estate-actions" v-if="! $root.is_mobile">
                        <template>
                            <estate-actions :estate="estate" />
                        </template>

                        <div class="share-button">
                            <estate-share
                                :estate="estate"
                                :estate-id="estate.id"
                                :agency-id="estate.agency ? estate.agency.id : null"
                                :type="estate.ad_type"
                            >
                            </estate-share>
                        </div>
                        <div class="ref" v-if="! $root.is_mobile">{{ lang.details.ref }}: {{ estate.id }}</div>
                    </div>
                </template>
            </div>

            <div v-if="costs && estate.costs.mortgage_payment_value" class="row">
                <div class="col p-0 hipotecas">
                    <modal-opener
                        name="calculate-mortgage"
                        class="calculate-mortgage"
                    >
                        <span>{{ lang.labels.hipotecas.replace(':value', estate.costs.mortgage_payment_value) }}</span>
                    </modal-opener>
                </div>
            </div>

            <div class="row">
                <div class="col-12 p-0">
                    <div class="estate-price" v-if="! $root.is_mobile">
                        <span class="current-price" v-html="estate.price"></span>
                        <span v-if="estate.price_alternative" class="current-price-euro" v-html="estate.price_alternative"></span>
                        <estate-discount :estate="estate" />
                    </div>

                    <div class="col-12 col-xl-7 p-0">
                        <div v-if="$root.is_mobile">
                            <h1 class="estate-title">
                                {{ estate.title }}
                            </h1>
                            <h2 class="estate-subtitle">
                                {{ estate.subtitle }}
                            </h2>
                        </div> 
                        <estate-card-data :estate="estate" />
                    </div>

                    <div class="text-left" v-if="!$root.is_mobile && estate.pdf">
                        <a
                            :href="estate.pdf"
                            target="_blank"
                            rel="nofollow"
                            class="btn btn-network print-pdf"
                        >
                            {{ trans('labels.print') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div class="container box-sticky">
            <div class="row">
                <div v-if="$root.is_mobile" class="d-flex align-items-center w-100">
                    <div class="col-9 estate-price">
                        <span class="current-price" v-html="estate.price"></span>
                        <span v-if="estate.price_alternative" class="current-price-euro" v-html="estate.price_alternative"></span>
                        <estate-discount :estate="estate" />
                    </div>
                    <!-- <estate-actions :estate="estate" />
                    <div class="share-button">
                        <estate-share
                            :estate="estate"
                            :estate-id="estate.id"
                            :agency-id="estate.agency ? estate.agency.id : null"
                            :type="estate.ad_type"
                            >
                        </estate-share>
                    </div> -->
                </div>

                <div class="col-xl-3 col-lg-4">
                    <h1 class="estate-title">
                        {{ estate.title }}
                    </h1>
                    <h2 class="estate-subtitle">
                        {{ estate.subtitle }}
                    </h2>
                    <div class="estate-fix"><estate-card-data :estate="estate" /></div>
                </div>

                <div class="col-auto" v-if="! $root.is_mobile">
                    <div class="estate-price">
                        <span class="current-price" v-html="estate.price"></span>
                        <span v-if="estate.price_alternative" class="current-price-euro" v-html="estate.price_alternative"></span>
                        <estate-discount :estate="estate" />
                    </div>
                </div>

                <div class="col-auto col-lg-auto estate-actions ml-auto">
                    <estate-actions :estate="estate" />
                    <div class="share-button">
                        <estate-share
                            :estate="estate"
                            :estate-id="estate.id"
                            :agency-id="estate.agency ? estate.agency.id : null"
                            :type="estate.ad_type"
                        >
                        </estate-share>
                    </div>
                </div>

                <div class="col-auto col-lg-auto estate-actions contactar ml-1">
                    <button
                        class="btn btn-network mt-1"
                        @click="contact"
                    >{{ lang.details.contact }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardData from './CardData'
import Discount from './Discount'
import Share from './Share'
import UserActions from './UserActions'
import ModalOpener from '../ModalOpener'
import { filterObject } from '../../helpers/objects'

export default {
    components: {
        'estate-actions': UserActions,
        'estate-card-data': CardData,
        'estate-discount': Discount,
        'estate-share': Share,
        'modal-opener': ModalOpener,
    },

    props: {
        backLink: {
            type: String,
            required: false,
        },

        estate: {
            type: Object,
            required: true,
        },

        lang: {
            type: Object,
            required: true,
        },

        showCalculateMortgage: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {}
    },

    computed: {
        costs() {
            return filterObject(this.estate.costs, item => {
                return item
            })
        },
    },

    created() {
        if (this.estate.ad_type == 'estate' && window.trackLibrary) {
            setTimeout(() =>
                window.trackLibrary.track('events.impressioneImmobile', {
                    immobile_id: this.estate.id,
                    agenzia_id: this.estate.agency.id,
                    tipoPagina: 'scheda',
                    nazione: this.estate.country,
                    origine: (window.location.search.substr(1).split('&').indexOf('origine=newsletter') !== -1) ? 'newsletter' : 'portale'
                })
            , 100)
        }

        // --- Gestione cookie
        var recent = JSON.parse($cookies.get('recent_' + this.estate.ad_type))
        if (recent) {
            recent.unshift(this.estate.id)
        } else {
            recent = [this.estate.id]
        }

        var recent_add = recent.filter(function(item, pos) {
            return recent.indexOf(item) == pos
        })

        $cookies.set('recent_' + this.estate.ad_type, JSON.stringify(recent_add.slice(0, 10)), '1y', '', '', true)
    },

    methods: {
        contact() {
            window.events.$emit('leadFormFocus')
        }
    },

}
</script>